<template>
  <div class="im-left">
    <div class="im-title">
      <h3>消息列表</h3>
      <!-- <i class="el-icon-s-custom"></i> -->
    </div>
    <!-- <el-input v-model="formSearch"></el-input> -->
    <div class="im-user-page" v-loading="loading">
      <el-empty v-if="!loading && !listFriends.length" description="暂无对话"></el-empty>
      <div v-else @click="onFriend(item)" class="im-user" v-for="(item, index) in listFriends" :key="index" :class="{ isSelect: cusId === item.id }">
        <el-badge v-if="item.newValue && item.newValue > 0" :value="item.newValue" :max="99" class="unread-badge">
          <el-avatar class="user-header" :size="60">
            <span>{{ customName(item.name) }}</span>
            <!-- <img src="../../assets/images/defaultUser.png" alt="" /> -->
          </el-avatar>
        </el-badge>
        <el-avatar v-else class="user-header" :size="60">
          <span>{{ customName(item.name) }}</span>
          <!-- <img src="../../assets/images/defaultUser.png" alt="" /> -->
        </el-avatar>
        <div>
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //   formSearch: undefined,
      listFriends: [],
      timer: null,
      loading: false,
      cusId: "",
    };
  },
  methods: {
    customName(name) {
      return name ? name.slice(0, 2) : "";
    },
    apiImfriendsList(query) {
      return this.$http.get("im/friends", { params: query });
    },
    unRead(query) {
      return this.$http.get("im/friends/unRead", { params: query });
    },
    clean(query) {
      return this.$http.get("im/friends/clean", { params: query });
    },
    async onFriend(item) {
      this.cusId = item.id;
      const params = {
        cusId: item.id,
      };
      const { data: res } = await this.clean(params);
      if (res.code === 200) {
        this.getFriends();
      }
      this.$emit("onChange", item);
    },
    async getFriends() {
      const { data: res } = await this.apiImfriendsList({});
      const { data: res2 } = await this.unRead({});
      const dataTwo = res2.data.map((v) => {
        return {
          key: Object.keys(v)[0],
          value: Object.values(v)[0],
        };
      });
      const obj = dataTwo.reduce((result, item) => {
        result[item.key] = item.value;
        return result;
      }, {});
      if (res.code === 200) {
        this.listFriends = res.data.map((v) => {
          return {
            ...v,
            newValue: obj[v.id],
          };
        });
      }
    },
  },
  mounted() {
    this.loading = true;
    this.getFriends().then(() => {
      this.loading = false;
      if (this.listFriends.length) {
        this.onFriend(this.listFriends[0]);
      }
    });
    this.timer = setInterval(() => {
      this.getFriends();
    }, 30 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style scoped lang="less">
@import url(./style.css);

.im-left {
  width: 400px;
  min-width: 400px;
  padding: 20px;
  background: white;
  border-radius: 10px;

  .im-title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-icon-s-custom {
      cursor: pointer;
    }
  }
}

.im-user-page {
  height: calc(100% - 100px);
  overflow-y: auto;
  margin-top: 10px;
  // background: #dcdfe6;

  .im-user {
    height: 80px;
    align-items: center;
    padding-left: 10px;
    &:hover {
      background: #ecf5ff;
    }
    .unread-badge {
      position: relative;
      left: 0;
      ::v-deep .el-badge__content.is-fixed {
        top: 6px;
        right: 15px;
      }
    }
  }
  .isSelect {
    background-color: #ecf5ff;
  }

  .user-header {
    margin-right: 10px;
  }

  .im-user:hover {
    /*background: #c8c7c6;*/
  }

  .user-headpic {
    width: 50px;
    height: 50px;
    border: 1px solid black;

    .picFriends {
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }
  }
}
</style>
